<template>
  <div ref="container">
    <svg
      ref="svg"
      :width="width"
      :height="height"
      class="x-axis overflow-visible"
    ></svg>
  </div>
</template>

<script>
import * as d3 from "d3";

export default {
  name: "XAxis",
  data() {
    return {
      width: 200,
      height: 20,
    };
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    domain: {
      type: Array,
      default: () => [0, 100],
    },
    tickValues: {
      type: Array,
      default: null,
    },
  },
  mounted() {
    this.setSize();
    this.create();
    window.addEventListener("resize", this.resize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  computed: {
    scale() {
      return d3
        .scaleLinear()
        .domain(this.domain)
        .range([0, this.width]);
    },
    xAxis() {
      let ticks = 4;
      // let tickValues = null;
      // if (this.width <= 500) {
      //   ticks = 2;
      //   tickValues = this.domain;
      // }
      return d3
        .axisBottom(this.scale)
        .ticks(ticks)
        .tickSize(this.height)
        .tickValues(this.tickValues)
        .tickFormat((d) => `${+Math.abs(d).toFixed(0)}%`);
    },
  },
  methods: {
    // toDate(e) {
    //   const date = e.split("-");
    //   return new Date(date[0], date[1] - 1, date[2]);
    // },
    setSize() {
      const container = this.$refs.container;
      this.width = container.clientWidth;
      this.height = container.clientHeight;
    },
    resize() {
      const currentWidth = this.width;
      const currentHeight = this.height;
      this.setSize();
      if (currentWidth !== this.width || currentHeight !== this.height) {
        this.update();
      }
    },
    update() {
      this.axisContainer
        .call(this.xAxis)
        .call((g) => g.select(".domain").remove())
        .call(
          (g) =>
            g
              // .selectAll(".tick:not(:first-of-type) line")
              .selectAll("line")
              .attr("stroke-opacity", 0.3)
          // .attr("stroke-dasharray", "2,2")
        );
    },
    create() {
      this.svg = d3.select(this.$refs.svg);

      //Append group and insert axis
      this.axisContainer = this.svg
        .append("g")
        .attr("transform", `translate(0,4)`);

      this.update();
    },
  },
};
</script>
<style>
/* .x-axis .domain {
  display: none;
} */
</style>
